import React from 'react'
import { getSubdomain } from '../../utils/general'
import subdomainStyles from '../../subdomainStyles.json'
import formatters from "../../utils/forms/formatters";
import {pullSubdomainStyleFromCookie} from "../../utils/subdomains/configHandlers";

export default class ContactEmail extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            email: null
        }
    }

    componentDidMount() {
        let subdomainStyles = pullSubdomainStyleFromCookie();
        let email = subdomainStyles['contact-email'] || 'support@cleanfi.com';
        this.setState({email})
    }

    render() {
        return (
            <a className={this.props.className} href={"mailto:" + this.state.email}>
                {this.state.email}
            </a>
        )
    }
}